const ACCESS_TOKEN_KEY = "showmust_access_token";
const REFRESH_TOKEN_KEY = "showmust_refresh_token";
const ADMIN_EMAIL_KEY = "showmust_admin_email";

export const setTokens = (accessToken: string, refreshToken: string): void => {
    localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
    localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
};

// Email вошедшего администратора — сохраняется при логине, используется для
// точечных UI-ограничений (например, скрытие иконки оплаты для конкретного админа).
export const setAdminEmail = (email: string): void => {
    localStorage.setItem(ADMIN_EMAIL_KEY, email.trim().toLowerCase());
};

export const getAdminEmail = (): string | null => {
    return localStorage.getItem(ADMIN_EMAIL_KEY);
};

export const getAccessToken = (): string | null => {
    return localStorage.getItem(ACCESS_TOKEN_KEY);
};

export const getRefreshToken = (): string | null => {
    return localStorage.getItem(REFRESH_TOKEN_KEY);
};

export const clearTokens = (): void => {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
    localStorage.removeItem(ADMIN_EMAIL_KEY);
};
